import { Layout } from './Components/Shared/Layout/Layout';
import { UserProvider } from './Contexts/User';
import { AxiosProvider } from './Contexts/Axios';
import { LocalizationProvider } from './Contexts/Localization';
import css from './App.module.scss';
import { ErrorBoundary, FallbackErrorBoundary } from './Components/Shared/ErrorBoundary/ErrorBoundary';
import { createTheme, StyledEngineProvider, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { SCREEN_LG, SCREEN_MD, SCREEN_SM, SCREEN_XL, SCREEN_XS } from './CommonUtils/MediaQueries';
import { MessageProvider } from './Contexts/Message';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AppCoreProvider } from './Contexts/AppCore';
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Changes to these fonts need to be applied to the top level index.scss file
 */
const bodyFontFamily = 'Titillium-Regular';

const theme = createTheme({
    typography: {
        fontFamily: bodyFontFamily,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 600,
        fontWeightBold: 700,
    },
    breakpoints: {
        values: {
            xs: SCREEN_XS,
            sm: SCREEN_SM,
            md: SCREEN_MD,
            lg: SCREEN_LG,
            xl: SCREEN_XL,
        },
    },
});

const App: React.FC = () => {
    return (
        <FallbackErrorBoundary>
            <div className={css.app}>
                <MUIThemeProvider theme={theme}>
                    <StyledEngineProvider injectFirst>
                        <AppCoreProvider>
                            <LocalizationProvider>
                                <ErrorBoundary>
                                    <AxiosProvider>
                                        <MessageProvider>
                                            <UserProvider>
                                                <Layout />
                                            </UserProvider>
                                        </MessageProvider>
                                    </AxiosProvider>
                                </ErrorBoundary>
                            </LocalizationProvider>
                        </AppCoreProvider>
                    </StyledEngineProvider>
                </MUIThemeProvider>
            </div>
        </FallbackErrorBoundary>
    );
};

export default App;